import React, { useCallback, useContext, useEffect, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { BrowseContext } from '../../../contexts/BrowseContext'
import axiosService from '../../../utils/AxiosService'
import { toastError, toastSuccess } from '../../FormComponents/Toasts'
import ClientCalendar from '../../Shared/ClientCalendar/ClientCalendar'
import ClientCalendarEventModal from '../../Shared/ClientCalendar/ClientCalendarEventModal'

export default observer(function ClientCalendarTab({ newEntryTick = 0 }) {
  const { selectedClient } = useContext(BrowseContext)
  const clientId = selectedClient?.id

  const [events, setEvents] = useState([])
  const [month, setMonth] = useState(() => {
    const now = new Date()
    return new Date(now.getFullYear(), now.getMonth(), 1)
  })
  const [modalOpen, setModalOpen] = useState(false)
  const [editingEvent, setEditingEvent] = useState(null)

  const apiBase = `/api/project_manager/clients/${clientId}/calendar_events`

  const fetchEvents = useCallback(() => {
    if (!clientId) return
    axiosService.get(apiBase).then(setEvents).catch(() => toastError('Failed to load calendar events'))
  }, [clientId])

  useEffect(() => { fetchEvents() }, [fetchEvents])

  // Open new entry modal whenever the header button increments the tick
  useEffect(() => {
    if (newEntryTick > 0) { setEditingEvent(null); setModalOpen(true) }
  }, [newEntryTick])

  const openEdit = (event) => { setEditingEvent(event); setModalOpen(true) }
  const closeModal = () => setModalOpen(false)

  const handleSave = async (form, id) => {
    const payload = { client_calendar_event: form }
    try {
      if (id) {
        await axiosService.patch(`${apiBase}/${id}`, payload)
        toastSuccess('Event updated')
      } else {
        await axiosService.post(apiBase, payload)
        toastSuccess('Event created')
      }
      fetchEvents()
    } catch {
      throw new Error(id ? 'Failed to update event' : 'Failed to create event')
    }
  }

  const handleDelete = async (id) => {
    try {
      await axiosService.delete(`${apiBase}/${id}`)
      toastSuccess('Event deleted')
      fetchEvents()
    } catch {
      toastError('Failed to delete event')
      throw new Error('Failed to delete event')
    }
  }

  return (
    <div className="h-full">
      <ClientCalendar
        events={events}
        month={month}
        onMonthChange={setMonth}
        onEdit={openEdit}
      />

      <ClientCalendarEventModal
        isOpen={modalOpen}
        onClose={closeModal}
        onSave={handleSave}
        onDelete={handleDelete}
        initialData={editingEvent}
      />
    </div>
  )
})
